var map = {
	"./Icon-1_cursor.svg": "d878",
	"./Icon-2_pointer.svg": "edf7",
	"./Icon-3_parchment.svg": "c09d",
	"./Icon-4_fire.svg": "0e1b",
	"./Icon-5_purse.svg": "a67b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e23";